/* Veer wishlist — localStorage favourites (custom build, no app). 2026-06-30.
   Hardened 2026-07-03 per L2 review: shape-validated storage, XSS-safe DOM building,
   dead-handle pruning, multi-instance state sync. */
(function () {
  var KEY = 'veer_wishlist';
  function read() {
    // L2 #3: tolerate malformed storage — only accept an array of non-empty strings
    try {
      var p = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(p) ? p.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} // tolerate restricted modes
    count(a.length);
  }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) { var a = read(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.push(h); write(a); return i === -1; }
  function count(n) {
    document.querySelectorAll('[data-veer-wish-count]').forEach(function (el) {
      el.textContent = n; el.toggleAttribute('hidden', n === 0);
    });
  }
  function mark() {
    document.querySelectorAll('[data-veer-wish]').forEach(function (b) {
      var on = has(b.getAttribute('data-handle'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-active', on);
    });
  }
  function ifEmpty() {
    var root = document.getElementById('veer-wishlist-root');
    if (root && !root.querySelector('.veer-wishlist-card')) {
      // static markup only (no dynamic data) — L2 innerHTML rule satisfied
      root.innerHTML =
        '<div class="veer-wishlist-empty">' +
        '<p>Nu ai produse favorite încă.</p>' +
        '<p class="veer-wishlist-empty__hint">Atinge inimioara de pe orice produs și îl salvezi aici.</p>' +
        '<a class="button" href="/collections/all">Continuă cumpărăturile</a>' +
        '<div class="veer-wishlist-empty__pills">' +
        '<a href="/collections/barbati">Bărbați</a>' +
        '<a href="/collections/dama">Damă</a>' +
        '<a href="/collections/copii">Copii</a>' +
        '</div></div>';
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-veer-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-handle');
    if (!h) return; // 2026-07-08 L2: never toggle/store a null/empty handle
    var on = toggle(h);
    mark(); // L2 #6: sync ALL buttons for this handle across the page, not just the clicked one
    if (b.closest('#veer-wishlist-root') && !on) {
      var c = b.closest('.veer-wishlist-card');
      if (c) c.remove();
      ifEmpty();
    }
  });
  // L2 #5: build cards with DOM APIs (dynamic product data via textContent/attributes, never innerHTML)
  function buildCard(h, p) {
    var price = ((p.price || 0) / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2 }) + ' lei';
    var imgUrl = p.featured_image
      ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=500'
      : '';
    var card = document.createElement('div');
    card.className = 'veer-wishlist-card';
    var a = document.createElement('a');
    a.className = 'veer-wishlist-card__link';
    a.href = '/products/' + encodeURIComponent(h);
    var media = document.createElement('div');
    media.className = 'veer-wishlist-card__media';
    if (imgUrl) {
      var im = document.createElement('img');
      im.src = imgUrl; im.alt = ''; im.loading = 'lazy';
      media.appendChild(im);
    }
    var title = document.createElement('div');
    title.className = 'veer-wishlist-card__title';
    title.textContent = p.title || '';
    var pr = document.createElement('div');
    pr.className = 'veer-wishlist-card__price';
    pr.textContent = price;
    a.appendChild(media); a.appendChild(title); a.appendChild(pr);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'veer-wish is-active';
    btn.setAttribute('data-veer-wish', '');
    btn.setAttribute('data-handle', h);
    btn.setAttribute('aria-pressed', 'true');
    btn.setAttribute('aria-label', 'Elimină din favorite');
    btn.innerHTML = '<svg class="veer-wish__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
    card.appendChild(a); card.appendChild(btn);
    return card;
  }
  function renderPage(root) {
    var handles = read();
    if (!handles.length) { ifEmpty(); return; }
    root.innerHTML = '';
    // Fetch all; distinguish 404 (dead -> prune) from transient failures (KEEP — localStorage is
    // the customer's only copy of their favourites). 2026-07-08 L2: never wipe favourites on a hiccup.
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : (r.status === 404 ? 'dead' : null); })
        .then(function (p) { return { h: h, p: p }; }) // p: object=ok, 'dead'=404, null=transient
        .catch(function () { return { h: h, p: null }; });
    })).then(function (results) {
      var rendered = 0;
      var dead = [];
      results.forEach(function (x) {
        if (x.p && x.p !== 'dead') { root.appendChild(buildCard(x.h, x.p)); rendered++; }
        else if (x.p === 'dead') dead.push(x.h);
      });
      // prune ONLY confirmed-dead handles, from the LATEST state (not the stale snapshot)
      if (dead.length) write(read().filter(function (h) { return dead.indexOf(h) === -1; }));
      if (!rendered && !root.querySelector('.veer-wishlist-card')) ifEmpty();
    });
  }
  function init() {
    mark();
    count(read().length);
    var root = document.getElementById('veer-wishlist-root');
    if (root) renderPage(root);
    var container = document.getElementById('ProductGridContainer');
    if (container && 'MutationObserver' in window) {
      new MutationObserver(function () { mark(); }).observe(container, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
